export default "__VITE_ASSET__d649aab0__"